export const getToastNotification = ({
  isComposingEmail,
  isEmailSaved,
  isSavingToTimeline,
  timeSaved,
  timeToSave,
  filesToSave,
}, beforeSave) => {
  const numFiles = filesToSave.length > 1 ? 'Files' : 'File';

  const toastNotifications = {
    emailPresaved: 'Email is ready to send',
    emailSaved: 'Email saved successfully',
    emailAndFilesSaved: `Email & ${numFiles} are saved.`,
    emailSavedFilesSaving: `Email is saved. ${filesToSave.length > 1 ? 'Files are' : 'File is'} saving. Feel free to move about the cabin`,
    timeSaving: 'Time is saving',
    timeSaved: 'Time is saved',
    emailAndTimeSaving: 'Email and Time are saving.',
    emailAndTimeSaved: 'Email and Time are saved',
    emailTimeAndFilesSaving: `Email, ${numFiles} & Time are saving.`,
    emailAndTimeSavedFilesSaving: 'Email and Time are saved. Files are saving. Feel free to move about the cabin',
    emailAndTimeSavedFileSaving: 'Email and Time are saved. File is saving. Feel free to move about the cabin',
    emailAndFilesSaving: `Email & ${numFiles} are saving. Feel free to move about the cabin.`,
    timeAndFilesSaving: `Time & ${numFiles} are saving`,
    timeSavedFilesSaving: `Time is saved. ${filesToSave.length > 1 ? 'Files are' : 'File is'} saving.`,
    fileSaving: 'File is saving',
    filesSaving: 'Files are saving.',
  };

  const emailSaving = isSavingToTimeline && !isEmailSaved;
  const allTimeSaved = timeSaved.length && !timeToSave.length;
  const emailAlreadySaved = beforeSave && isEmailSaved;
  const timeAlreadySaved = beforeSave && allTimeSaved;

  if (!beforeSave && isComposingEmail) {
    return toastNotifications.emailPresaved;
  }

  if (emailAlreadySaved && timeAlreadySaved && filesToSave.length) {
    return filesToSave.length > 1 ? toastNotifications.filesSaving : toastNotifications.fileSaving;
  } else if (emailAlreadySaved && timeToSave.length && filesToSave.length) {
    return toastNotifications.timeAndFilesSaving;
  } else if (isEmailSaved && allTimeSaved && filesToSave.length) {
    return filesToSave.length > 1 ? toastNotifications.emailAndTimeSavedFilesSaving : toastNotifications.emailAndTimeSavedFileSaving;
  } else if (isEmailSaved && allTimeSaved) {
    return toastNotifications.emailAndTimeSaved;
  } else if (isEmailSaved && filesToSave.length) {
    return toastNotifications.emailSavedFilesSaving;
  } else if (allTimeSaved && filesToSave.length) {
    return toastNotifications.timeSavedFilesSaving;
  } else if (emailSaving && timeToSave.length && filesToSave.length) {
    return toastNotifications.emailTimeAndFilesSaving;
  } else if (emailSaving && filesToSave.length) {
    return toastNotifications.emailAndFilesSaving;
  } else if (emailSaving && timeToSave.length) {
    return toastNotifications.emailAndTimeSaving;
  } else if (timeToSave.length) {
    return toastNotifications.timeSaving;
  } else if (timeSaved.length) {
    return toastNotifications.timeSaved;
  } else if (filesToSave.length) {
    return filesToSave.length > 1 ? toastNotifications.filesSaving : toastNotifications.fileSaving;
  } else if (isEmailSaved) {
    return toastNotifications.emailSaved;
  }
};
